import { appApi } from '../app_api';

export const eventApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getEvent: builder.query({
      query: (id) => `/events/${id}`,
      transformResponse: (response) => response.event,
      providesTags: (result, error, id) => [{ type: 'Event', id }],
    }),
    getEventDivisions: builder.query({
      query: (eventId) => `/events/${eventId}/divisions`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, eventId) => [{ type: 'EventDivisions', id: eventId }],
    }),
    getEventManagerPermissions: builder.query({
      query: (eventId) => `/events/${eventId}/manager_permissions`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, eventId) => [{ type: 'EventManagerPermissions', id: eventId }],
    }),
    updateEventManagerPermission: builder.mutation({
      query: ({ eventId, managerId, permission, value }) => ({
        url: `/events/${eventId}/update_manager_permission`,
        method: 'PUT',
        body: { manager_id: managerId, permission, value },
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'EventManagerPermissions', id: eventId }],
    }),
    changeScoringPermission: builder.mutation({
      query: ({ eventId, scoringPermissionId }) => ({
        url: `/events/${eventId}/change_scoring_permission`,
        method: 'PUT',
        body: { scoringPermissionId },
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'Event', id: eventId }],
    }),
    // Lists the event's score-entry QR codes (one per group that has one).
    getScoreEntryTokens: builder.query({
      query: (eventId) => `/events/${eventId}/score_entry_tokens`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, eventId) => [{ type: 'EventScoreEntryTokens', id: eventId }],
    }),
    // Reversibly enables/disables a single QR code.
    toggleScoreEntryToken: builder.mutation({
      query: ({ eventId, tokenId, disabled }) => ({
        url: `/events/${eventId}/score_entry_tokens/${tokenId}`,
        method: 'PATCH',
        body: { disabled },
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'EventScoreEntryTokens', id: eventId }],
    }),
    // Invalidates every score-entry QR code already printed for the event.
    revokeScoreEntryTokens: builder.mutation({
      query: ({ eventId }) => ({
        url: `/events/${eventId}/score_entry_tokens`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'EventScoreEntryTokens', id: eventId }],
    }),
    finishEvent: builder.mutation({
      query: ({ eventId }) => ({
        url: `/events/${eventId}/finish_event`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, { eventId }) => [{ type: 'Event', id: eventId }],
    }),
    createDemo: builder.mutation({
      query: ({ userData, platform }) => ({
        url: `/events/create_demo`,
        method: 'POST',
        body: { userData, platform },
      }),
      transformResponse: (response) => response,
    }),
  }),
});

export const {
  useGetEventQuery,
  useLazyGetEventQuery,
  useGetEventDivisionsQuery,
  useGetEventManagerPermissionsQuery,
  useUpdateEventManagerPermissionMutation,
  useChangeScoringPermissionMutation,
  useGetScoreEntryTokensQuery,
  useToggleScoreEntryTokenMutation,
  useRevokeScoreEntryTokensMutation,
  useFinishEventMutation,
  useCreateDemoMutation,
} = eventApi;
